import styled from "@emotion/styled";
import { CircularProgress, IconButton, InputAdornment } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import { TextField } from "@shared/components/TextField";

const FiltersContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  justify-content: flex-end;
  align-items: flex-end;
  gap: 1rem;
  margin-bottom: 1rem;
`;

type ContactsFilterBarProps = {
  filterValue: string;
  onFilterValueChange: (value: string) => void;
  isSearching?: boolean;
};

export const ContactsFilterBar = (props: ContactsFilterBarProps) => {
  const { filterValue, onFilterValueChange, isSearching } = props;

  const handleFilterInputChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    onFilterValueChange(event.target.value);
  };

  return (
    <FiltersContainer>
      <TextField
        name="contacts-filter-value"
        placeholder="Search contacts..."
        onChange={handleFilterInputChange}
        value={filterValue}
        autoFocus
        InputProps={{
          endAdornment: (
            <InputAdornment position="end" sx={{ mr: 0.5 }}>
              {filterValue ? (
                isSearching ? (
                  <IconButton size="small">
                    <CircularProgress size={20} color="primary" />
                  </IconButton>
                ) : (
                  <IconButton
                    size="small"
                    onClick={() => onFilterValueChange("")}
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                )
              ) : (
                <SearchIcon fontSize="small" color="primary" sx={{ mr: 0.5 }} />
              )}
            </InputAdornment>
          ),
        }}
        hideHelperTextSpace
      />
    </FiltersContainer>
  );
};
